/**
 * public-locale — locale-prefix utilities for public (pre-auth) routes.
 *
 * multilingual-seo.md M2: indexable pages live at /ko/… and /zh-TW/… beside
 * the canonical en URLs. This module owns the prefix vocabulary and the
 * pathname↔(locale, path) mapping so views and links agree on one parser.
 */


/** Locales with an indexable prefix shell (plan M1/M3/M5: ko + zh-TW + ja). */
export const PUBLIC_LOCALES = ['ko', 'zh-TW', 'ja'] as const
export type PublicLocale = (typeof PUBLIC_LOCALES)[number]

export function isPublicLocale(v: string | undefined): v is PublicLocale {
  return !!v && (PUBLIC_LOCALES as readonly string[]).includes(v)
}

/** `/ko/blog/x` → { locale: 'ko', path: '/blog/x' }; unprefixed → itself. */
export function splitLocalePath(pathname: string): {
  locale?: PublicLocale
  path: string
} {
  const m = pathname.match(/^\/(ko|zh-TW|ja)(\/.*)?$/)
  if (m && isPublicLocale(m[1])) {
    return { locale: m[1], path: m[2] ?? '/' }
  }
  return { path: pathname }
}
